window.MIRA_WILAYA_RATES = {
  "01": { name: "Adrar", office: 700, home: 1300, delay: "J+5" },
  "02": { name: "Chlef", office: 450, home: 750, delay: "J+1" },
  "03": { name: "Laghouat", office: 450, home: 850, delay: "J+1" },
  "04": { name: "Oum El Bouaghi", office: 450, home: 850, delay: "J+1" },
  "05": { name: "Batna", office: 450, home: 850, delay: "J+1" },
  "06": { name: "Béjaïa", office: 450, home: 800, delay: "J+1" },
  "07": { name: "Biskra", office: 550, home: 900, delay: "J+1" },
  "08": { name: "Béchar", office: 500, home: 1000, delay: "J+3" },
  "09": { name: "Blida", office: 450, home: 800, delay: "J+1" },
  "10": { name: "Bouira", office: 450, home: 800, delay: "J+1" },
  "11": { name: "Tamanrasset", office: 800, home: 1600, delay: "J+5" },
  "12": { name: "Tébessa", office: 500, home: 900, delay: "J+1" },
  "13": { name: "Tlemcen", office: 450, home: 850, delay: "J+1" },
  "14": { name: "Tiaret", office: 300, home: 350, delay: "J+1" },
  "15": { name: "Tizi Ouzou", office: 450, home: 800, delay: "J+1" },
  "16": { name: "Alger", office: 450, home: 700, delay: "J+1" },
  "17": { name: "Djelfa", office: 450, home: 750, delay: "J+1" },
  "18": { name: "Jijel", office: 450, home: 800, delay: "J+1" },
  "19": { name: "Sétif", office: 450, home: 800, delay: "J+1" },
  "20": { name: "Saïda", office: 450, home: 800, delay: "J+1" },
  "21": { name: "Skikda", office: 450, home: 800, delay: "J+1" },
  "22": { name: "Sidi Bel Abbès", office: 450, home: 750, delay: "J+1" },
  "23": { name: "Annaba", office: 450, home: 850, delay: "J+1" },
  "24": { name: "Guelma", office: 450, home: 800, delay: "J+1" },
  "25": { name: "Constantine", office: 450, home: 800, delay: "J+1" },
  "26": { name: "Médéa", office: 450, home: 750, delay: "J+1" },
  "27": { name: "Mostaganem", office: 450, home: 750, delay: "J+1" },
  "28": { name: "M'Sila", office: 450, home: 800, delay: "J+1" },
  "29": { name: "Mascara", office: 450, home: 700, delay: "J+1" },
  "30": { name: "Ouargla", office: 500, home: 950, delay: "J+2" },
  "31": { name: "Oran", office: 450, home: 650, delay: "J+1" },
  "32": { name: "El Bayadh", office: 450, home: 800, delay: "J+2" },
  "33": { name: "Illizi", office: 1300, home: 2000, delay: "J+3" },
  "34": { name: "Bordj Bou Arreridj", office: 450, home: 800, delay: "J+1" },
  "35": { name: "Boumerdès", office: 450, home: 800, delay: "J+1" },
  "36": { name: "El Tarf", office: 550, home: 900, delay: "J+1" },
  "37": { name: "Tindouf", office: null, home: 1600, delay: "J+5" },
  "38": { name: "Tissemsilt", office: 450, home: 750, delay: "J+1" },
  "39": { name: "El Oued", office: 550, home: 950, delay: "J+2" },
  "40": { name: "Khenchela", office: 500, home: 900, delay: "J+1" },
  "41": { name: "Souk Ahras", office: 550, home: 900, delay: "J+1" },
  "42": { name: "Tipaza", office: 450, home: 850, delay: "J+1" },
  "43": { name: "Mila", office: 450, home: 850, delay: "J+2" },
  "44": { name: "Aïn Defla", office: 450, home: 850, delay: "J+1" },
  "45": { name: "Naâma", office: 450, home: 850, delay: "J+2" },
  "46": { name: "Aïn Témouchent", office: 450, home: 800, delay: "J+1" },
  "47": { name: "Ghardaïa", office: 550, home: 950, delay: "J+2" },
  "48": { name: "Relizane", office: 450, home: 750, delay: "J+1" },
  "49": { name: "Timimoun", office: null, home: 1500, delay: "J+5" },
  "50": { name: "Bordj Badji Mokhtar", office: null, home: 1500, delay: "J+6" },
  "51": { name: "Ouled Djellal", office: 500, home: 1000, delay: "J+2" },
  "52": { name: "Béni Abbès", office: null, home: 1100, delay: "J+3" },
  "53": { name: "In Salah", office: 800, home: 1600, delay: "J+5" },
  "54": { name: "In Guezzam", office: 1000, home: 2000, delay: "J+5" },
  "55": { name: "Touggourt", office: 550, home: 1000, delay: "J+2" },
  "56": { name: "Djanet", office: 1000, home: 2000, delay: "J+5" },
  "57": { name: "El M'Ghair", office: 500, home: 1000, delay: "J+3" },
  "58": { name: "El Meniaa", office: null, home: 1000, delay: "J+3" }
};